import { HERO_IMAGE, Wordmark, scrollToMenu, scrollToId } from "@/components/brand/BrandAssets";

const T = {
  tagline: { lv: "Liepāja · Neapoles pica ar piegādi un līdzņemšanu", ru: "Лиепая · Неаполитанская пицца с доставкой и самовывозом", en: "Liepāja · Neapolitan pizza, delivery & pickup" },
  order: { lv: "Pasūtīt", ru: "Заказать", en: "Order now" },
  menu: { lv: "Ēdienkarte", ru: "Меню", en: "Menu" },
  story: { lv: "Mūsu stāsts", ru: "Наша история", en: "Our story" },
  heroAlt: {
    lv: "Picas mīklas stiepšana uz miltiem nokaisīta galda pie malkas krāsns",
    ru: "Растягивание теста для пиццы на присыпанном мукой столе у дровяной печи",
    en: "Stretching pizza dough on a flour-dusted counter by the wood-fired oven",
  },
};

const BrandHero = ({ language, statusText, isOpen }) => {
  const t = (k) => T[k][language] || T[k].lv;

  return (
    <section className="relative w-full h-[100svh] min-h-[600px] max-h-[960px] overflow-hidden bg-[#1C1917]" data-testid="brand-hero">
      <img
        src={HERO_IMAGE}
        alt={t("heroAlt")}
        className="absolute inset-0 w-full h-full object-cover object-[50%_45%]"
        fetchpriority="high"
        decoding="async"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0c0a09]/85 via-[#0c0a09]/30 to-[#0c0a09]/25" aria-hidden="true" />

      <div className="relative z-10 h-full max-w-[1400px] mx-auto px-5 sm:px-8 flex flex-col justify-end pb-12 sm:pb-16">
        <p className="rz-eyebrow !text-[#FDFBF7]/80 mb-6 rz-reveal" data-testid="hero-tagline">{t("tagline")}</p>
        <h1 className="m-0 rz-reveal rz-reveal--2" data-testid="hero-wordmark">
          <Wordmark size="hero" tone="light" />
        </h1>

        <div className="mt-10 sm:mt-12 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-5 rz-reveal rz-reveal--3">
          <button onClick={scrollToMenu} className="rz-btn rz-btn--light w-full sm:w-auto min-w-[200px]" data-testid="hero-order-button">
            {t("order")}
          </button>
          <button onClick={() => scrollToId("about-section")} className="rz-btn rz-btn--light-outline w-full sm:w-auto min-w-[200px]" data-testid="hero-story-button">
            {t("story")}
          </button>
          {statusText && (
            <p className="m-0 sm:ml-auto inline-flex items-center gap-3 text-[0.72rem] font-medium tracking-[0.2em] uppercase text-[#FDFBF7]/85" data-testid="restaurant-status-line">
              <span className={`inline-block w-1.5 h-1.5 rounded-full ${isOpen ? "bg-[#86efac]" : "bg-[#FDFBF7]/40"}`} aria-hidden="true" />
              {statusText}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default BrandHero;
